<template>
  <header class="portal-page-header" :class="{ 'portal-page-header--home': home }">
    <div class="portal-page-header__left">
      <v-btn
        v-if="!home"
        variant="text"
        :prepend-icon="backIcon"
        class="portal-page-header__back text-medium-emphasis px-0"
        @click="goBack"
      >
        {{ backLabel }}
      </v-btn>

      <div v-if="title || subtitle" class="portal-page-header__titles min-w-0">
        <h1
          v-if="title"
          class="text-h5 text-md-h4 font-weight-bold mb-1"
          :style="{ color: 'var(--portal-primary)' }"
        >
          {{ title }}
        </h1>
        <p
          v-if="subtitle"
          class="text-body-2 text-md-body-1 text-medium-emphasis mb-0"
        >
          {{ subtitle }}
        </p>
      </div>
    </div>

    <div
      v-if="mostrarColumnaDerecha"
      class="portal-page-header__right"
      :class="{
        'portal-page-header__right--without-switch': !mostrarPortalActivo,
      }"
    >
      <portal-active-switch
        v-if="mostrarPortalActivo"
        :model-value="activePortalSwitchKey"
        :items="portalSwitchItems"
        :active-icon="activePortalSwitchIcon"
        :alternate-portal="visualizandoFamiliar"
        :dark-theme="darkTheme"
        class="portal-page-header__portal-switch flex-shrink-0"
        @update:model-value="onActivePortalChange"
      />

      <div v-if="$slots.actions" class="portal-page-header__actions">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script>
import enums from "../../utils/enums";
import PortalActiveSwitch from "./PortalActiveSwitch.vue";

export default {
  name: "PortalPageHeader",
  components: { PortalActiveSwitch },
  inject: {
    portalHomeLayout: { default: null },
  },
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    backLabel: {
      type: String,
      default: "Volver al inicio",
    },
    backTo: {
      type: String,
      default: "/",
    },
    hidePortalSwitch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backIcon: enums.icons.BACK,
    };
  },
  computed: {
    portalSwitchItems() {
      return this.portalHomeLayout?.portalSwitchItems ?? [];
    },
    activePortalSwitchKey() {
      return this.portalHomeLayout?.activePortalSwitchKey ?? "titular";
    },
    activePortalSwitchIcon() {
      return this.portalHomeLayout?.activePortalSwitchIcon ?? enums.icons.ACCOUNT;
    },
    visualizandoFamiliar() {
      return this.portalHomeLayout?.visualizandoFamiliar === true;
    },
    darkTheme() {
      return this.portalHomeLayout?.darkMode === true;
    },
    tieneVinculosFamiliares() {
      return (this.portalHomeLayout?.familiaresConfirmados?.length ?? 0) > 0;
    },
    rutaPermitePortalFamiliar() {
      if (typeof this.portalHomeLayout?.isPersonalPortalPath !== "function") {
        return false;
      }
      return !this.portalHomeLayout.isPersonalPortalPath(this.$route.path);
    },
    mostrarPortalActivo() {
      return (
        !this.hidePortalSwitch &&
        this.tieneVinculosFamiliares &&
        this.rutaPermitePortalFamiliar
      );
    },
    mostrarColumnaDerecha() {
      return !!(this.mostrarPortalActivo || this.$slots.actions);
    },
  },
  methods: {
    goBack() {
      if (this.$route.path === this.backTo) return;
      this.$router.push({ path: this.backTo }).catch(() => {});
    },
    onActivePortalChange(key) {
      this.portalHomeLayout?.seleccionarPortalPorKey?.(key);
    },
  },
};
</script>

<style scoped>
.portal-page-header {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 300px);
  align-items: start;
  gap: 16px;
  margin-bottom: 16px;
}
.portal-page-header__left,
.portal-page-header__right {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}
.portal-page-header__back {
  align-self: flex-start;
  min-height: 40px;
}
.portal-page-header__titles {
  width: 100%;
}
.portal-page-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.portal-page-header:not(.portal-page-header--home)
  .portal-page-header__right--without-switch {
  padding-top: 48px;
}
.portal-page-header__portal-switch {
  width: 100%;
}
@media (max-width: 599px) {
  .portal-page-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .portal-page-header__left,
  .portal-page-header__right {
    display: contents;
  }
  .portal-page-header__back {
    order: 1;
  }
  .portal-page-header__portal-switch {
    order: 2;
  }
  .portal-page-header__titles {
    order: 3;
  }
  .portal-page-header--home .portal-page-header__titles {
    order: 1;
  }
  .portal-page-header__actions {
    order: 4;
    width: 100%;
    padding-top: 0;
  }
  .portal-page-header:not(.portal-page-header--home)
    .portal-page-header__right--without-switch {
    padding-top: 0;
  }
  .portal-page-header__actions :deep(.v-btn) {
    width: 100%;
  }
}
</style>
